import { isProbablyImage } from '@pages/Library/utils/mediaStatus';
import { useMemo } from 'react';
import { MediaTableRow } from '../cells/types';

export interface VideoStats {
  nVideos: number;
  totalDuration: number;
}

export const useVideoStats = (mediaData: MediaTableRow[]): VideoStats => {
  // Compute video count and total duration for header.
  // Images (frameCount === 1) are excluded from both — they aren't videos and
  // their fractional-second duration would inflate the total.
  const videoStats = useMemo(() => {
    const videos = mediaData.filter(
      (media) =>
        !(media as any).isUploading && media.metadata?.video?.duration && !isProbablyImage(media),
    );
    const nVideos = videos.length;
    const totalDuration = videos.reduce(
      (sum, media) => sum + (media.metadata?.video?.duration || 0),
      0,
    );
    return { nVideos, totalDuration };
  }, [mediaData]);

  return videoStats;
};
